import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ACCOUNT_BALANCES } from "../../../api/queryKeys";
import {
  QueryAccountBalanceResponse,
  ChartTypePeriod,
  ChartTypeQuery,
} from "../../../types";

export const getBalanceData = (
  period: ChartTypePeriod,
  query: ChartTypeQuery
) =>
  api
    .get<QueryAccountBalanceResponse>(QUERY_ACCOUNT_BALANCES, {
      params: { period, query },
    })
    .then((res) => res.data);

export default function useGetAccountBalances(
  period: ChartTypePeriod,
  query: ChartTypeQuery
) {
  return useQuery([QUERY_ACCOUNT_BALANCES, period, query], () =>
    getBalanceData(period, query)
  );
}
